import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
    getCandidateJobDetails,
    getProfile,
    postExpSalaryDetails,
    postSalaryDetails,
    postStage,
    postOnboarding,
    getSalaryDetails,
    updateSalaryDetails,
    updateExpSalaryDetails,
    postReportingDetails,
    updateReportingDetails,
    getReportingDetails,
    postTimeline,
    getOfferDetails,
} from '../service/RecruiterApi';
import GenerateOfferletter from './GenerateOfferletter';
import EvaluationPopUp from '../components/EvaluationPopUp';
import { OnlyAlphabets, OnlyNumberAlphabetSpace } from '../../src/utils/RegHandling';
import Loader from '../StaticComponent/Loader';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';

function OfferLetter() {
    const personalDetails = {
        first_name: '',
        middle_name: '',
        last_name: '',
        gender: '',
        dob: '',
        street: '',
        city: '',
        state: '',
        country: '',
        zipcode: '',
        email: '',
        contactNumber: '',
        alternateContact: '',
    };

    const defaultJobDetail = {
        department: '',
        employment_type: '',
        job_id: '',
        job_title: '',
        location: '',
        stage: '',
        status: '',
        posted_by: '',
        offerValid: '',
        HRPartner: '',
        reportingManager: '',
        reporting_id: '',
    };

    let salaryDetails = {
        id: '',
        annualCtc: '',
        currency: '',
        HRsign: '',
        effectiveDate: '',
    };
    const search = window.location.search;
    const candidate_id = new URLSearchParams(search).get('id');
    const experience = new URLSearchParams(search).get('exp');
    const final = new URLSearchParams(search).get('round');
    const jid = new URLSearchParams(search).get('jid');
    const [round, setround] = useState(final);

    const [candidateSalaryDetails, setCandidateSalaryDetails] = useState(salaryDetails);
    const [SalaryDetailsID, setSalaryDetailsID] = useState('');

    const [jobDetails, setJobDetails] = useState(defaultJobDetail);

    const [isDisabled, setIsDisabled] = useState(true);
    const [showJobDetails, setShowJobDetails] = useState(true);
    const [showOfferDetails, setShowOfferDetails] = useState(true);
    const [greenOffer, setgreenOffer] = useState(true);
    const [greenSalary, setgreenSalary] = useState(true);
    const [overviewData, setOverviewData] = useState(personalDetails);
    const [candidateJobsData, setCandidateJobsData] = useState(defaultJobDetail);
    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const [annualctcvalidation, setannualctcvalidation] = useState('');
    const [hrSignValidation, sethrSignValidation] = useState('');
    const [currencyValidation, setcurrencyValidation] = useState('');
    const [offervalid, setoffervalid] = useState('');
    const [hrmanager, sethrmanager] = useState('');
    const [report, setReport] = useState('');
    const [effectDate, seteffectDate] = useState('');
    const [hideOfferLetter, setHideOfferLetter] = useState(false);
    const [hideInputField, setHideInputField] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        //;
        if (encryptStorage.getItem('groupid') != 1 || encryptStorage.getItem('recruitRole') != 'Panel Member') {
            loadData();
            getSalaryData();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    const getSalaryData = async () => {
        let data = {
            candidate_id: candidate_id,
            exp: experience,
        };
        let response = await getSalaryDetails(data);

        setCandidateSalaryDetails({
            annualCtc: response.data?.data[0]?.annual_ctc,
            currency: response.data?.data[0]?.currency_id,
            HRsign: response.data?.data[0]?.hr_signature_url,
            effectiveDate: moment(response.data?.data[0]?.effective_date).format('YYYY-MM-DD'),
            id: response.data?.data[0]?.id,
        });
        if (response.data?.statusCode == 400) {
            setSalaryDetailsID(null);
        } else {
            setSalaryDetailsID(response.data?.data[0]?.id);
        }
        // setSalaryDetailsID(response.data?.data[0]?.id);
    };

    let loadData = async () => {
        try {
            let resp1 = await getProfile({
                id: candidate_id,
                experience: experience,
            });

            var value = resp1.data.data[0];
            let respObj = {
                first_name: value.first_name,
                middle_name: value.middle_name,
                last_name: value.last_name,
                mobile_number: value.mobile_number,
                alternate_mobile_number: value.alternate_mobile_number,
                gender: value.gender,
                date_of_birth: value.date_of_birth,
                email_id: value.email_id,
                house: value.house,
                street: value.street,
                city: value.city,
                area: value.area,
                country: value.country,
                state: value.state,
                pincode: value.pincode,
                portfolio_link: value.portfolio_link,
                interview_source: value.interview_source,
                resume_url: value.resume_url,
            };

            setOverviewData(respObj);

            getCandidateJobDetails({
                candidate_id: candidate_id,
                experience: experience,
            }).then((resp2) => {
                var object = {
                    department: resp2.data.data[0].department,
                    employment_type: resp2.data.data[0].employment_type,
                    job_id: resp2.data.data[0].job_id,
                    job_title: resp2.data.data[0].job_title,
                    location: resp2.data.data[0].location,
                    stage: resp2.data.data[0].stage,
                    status: resp2.data.data[0].status,
                    posted_by: resp2.data.data[0].emp_name,
                };
                setCandidateJobsData((candidateJobsData) => ({ ...candidateJobsData, ...object }));
            });

            const response = await getReportingDetails({ candidate_id, exp: experience });
            let data = {
                offerValid: moment(response.data.data[0].offer_valid_till).format('YYYY-MM-DD'),
                HRPartner: response.data.data[0].hr_manager,
                reportingManager: response.data.data[0].reporting_manager,
                reporting_id: response.data.data[0].reporting_id,
            };
            setCandidateJobsData((candidateJobsData) => ({ ...candidateJobsData, ...data }));
            const offerDetailsResponse = await getOfferDetails({ id: candidate_id, experience: experience });

            if (offerDetailsResponse.data.data[0].offerletter_status == 'Offer Sent') {
                setHideOfferLetter(true);

                setHideInputField(true);
            }
        } catch (e) { }
    };

    const handleDetails = (e) => {
        setCandidateJobsData((jobDetails) => ({
            ...jobDetails,
            [e.target.name]: e.target.value,
        }));
        if (jobDetails.offerValid !== '' && jobDetails.reportingManager !== '' && jobDetails.HRPartner !== '') {
            setgreenOffer(false);
        }
    };
    let validation = () => {
        try {
            let result = true;

            if (
                candidateSalaryDetails.currency == '' ||
                candidateSalaryDetails.currency == 'Select' ||
                candidateSalaryDetails.currency == undefined
            ) {
                setcurrencyValidation('Currency is required');
                result = false;
            } else {
                setcurrencyValidation('');
            }
            if (candidateSalaryDetails.annualCtc === '') {
                setannualctcvalidation('Annual CTC is required');
                result = false;
            } else {
                // Function to check if the string contains only numbers, alphabets, and spaces
                const OnlyNumberAlphabetSpace = (str) => /^[a-zA-Z0-9 ]+$/.test(str);
                
                // Check if the input is valid and doesn't contain "LPA"
                if (!OnlyNumberAlphabetSpace(candidateSalaryDetails.annualCtc) || 
                    !candidateSalaryDetails.annualCtc.toLowerCase().includes('ctc')) {
                    setannualctcvalidation('Valid Annual CTC is required ');
                    result = false;
                } else {
                    setannualctcvalidation('');
                }
            }
            
            if (
                candidateSalaryDetails.HRsign == '' ||
                candidateSalaryDetails.HRsign == 'Select' ||
                candidateSalaryDetails.HRsign == undefined
            ) {
                sethrSignValidation('HR Signature is required');
                result = false;
            } else {
                sethrSignValidation('');
            }

            if (final !== 'fr' && (candidateJobsData.offerValid == '' || candidateJobsData.offerValid == undefined)) {
                setoffervalid('Offer Valid Till is required');
                result = false;
            } else {
                setoffervalid('');
            }
            if (final !== 'fr' && (candidateJobsData.reportingManager == '' || candidateJobsData.reportingManager == undefined)) {
                setReport('Reporting Manager is required');
                result = false;
            } else {
                let checkregex = OnlyAlphabets(candidateJobsData.reportingManager);
                if (checkregex) {
                    setReport('Valid Reporting Manager is required');
                    result = false;
                } else {
                    setReport('');
                }
            }
            if (final !== 'fr' && (candidateJobsData.HRPartner == '' || candidateJobsData.HRPartner == undefined)) {
                sethrmanager('HR Partner is required');
                result = false;
            } else {
                let checkregex = OnlyAlphabets(candidateJobsData.HRPartner);
                if (checkregex) {
                    sethrmanager('Valid HR Partner is required');
                    result = false;
                } else {
                    sethrmanager('');
                }
            }
            if (final !== 'fr' && (candidateSalaryDetails.effectiveDate == '' || candidateSalaryDetails.effectiveDate == undefined)) {
                seteffectDate('HR Partner is required');
                result = false;
            } else {
                seteffectDate('');
            }
            return result;
        } catch (e) {
            throw e;
        }
    };

    const handleSalaryDetails = (e) => {
        setCandidateSalaryDetails((jobDetails) => ({
            ...jobDetails,
            [e.target.name]: e.target.value,
        }));
        if (candidateSalaryDetails.HRsign !== '' && candidateSalaryDetails.currency !== '' && candidateSalaryDetails.annualCtc !== '') {
            setgreenSalary(false);
        }
    };
    const [saveClick,setSaveClick] = useState(false)
    const next = async () => {
        
        let salaryData;
        let reportingData;
        let offer_valid_date = `${candidateJobsData.offerValid} 00:00:00`;

        if (final == 'fr') {
            salaryData = {
                candidate_id: candidate_id,
                effective_date: null,
                currency_id: candidateSalaryDetails.currency,
                annual_ctc: candidateSalaryDetails.annualCtc,
                hr_signature_url: candidateSalaryDetails.HRsign,
            };
        } else {
            reportingData = {
                offer_valid: offer_valid_date,
                reporting_manager: candidateJobsData.reportingManager,
                hr_manager: candidateJobsData.HRPartner,
                candidate_id: candidate_id,
                exp: experience,
            };
            salaryData = {
                candidate_id: candidate_id,
                effective_date: candidateSalaryDetails.effectiveDate,
                currency_id: candidateSalaryDetails.currency,
                annual_ctc: candidateSalaryDetails.annualCtc,
                hr_signature_url: candidateSalaryDetails.HRsign,
            };
        }

        if (validation() == true) {
            setSaveClick(true)
            if (experience == 'Fresher') {
                let response = '';
                let response1 = '';
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                    response = await postSalaryDetails(salaryData);
                } else {
                    response = await updateSalaryDetails(salaryData);
                }
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                    response1 = await postReportingDetails(reportingData);
                } else {
                    response1 = await updateReportingDetails(reportingData);
                }
                if (response.data.statusCode == 200) {
                }
                let data = {
                    exp: 'Fresher',
                    candidate_id: candidate_id,
                    stage: 'Interviews',
                    job_position: candidateJobsData.job_title,
                    job_id: candidateJobsData.job_id,
                };
                postStage(data).then((res) => {
                    if (res.data.statusCode == 200) {
                    }
                });
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                postOnboarding(data).then((res) => {
                    if (res.data.statusCode == 200) {
                        navigate(0)
                    }
                });
            }
            } else if (experience == 'Experienced') {
                let response = '';
                let response1 = '';
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                    response = await postExpSalaryDetails(salaryData);
                } else {
                    response = await updateExpSalaryDetails(salaryData);
                }
                if (response.data.statusCode == 200) {
                }
                if (response.data.statusCode == 200) {
                }
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                    response1 = await postReportingDetails(reportingData);
                } else {
                    response1 = await updateReportingDetails(reportingData);
                }
                let data = {
                    exp: 'Experienced',
                    candidate_id: candidate_id,
                    stage: 'Interviews',
                    job_position: candidateJobsData.job_title,
                    job_id: candidateJobsData.job_id,
                };
                postStage(data).then((res) => {
                    if (res.data.statusCode == 200) {
                    }
                });
                if (SalaryDetailsID == undefined || SalaryDetailsID == null || SalaryDetailsID == '') {
                postOnboarding(data).then((res) => {
                    if (res.data.statusCode == 200) {
                        navigate(0)
                    }
                });
            }
            }
            
            setinsertToast(true);
            setToastColor('green');

            setToastPara('Offer Details is submitted');
            setToastValue('Successfully Submitted');
            setSaveClick(false)
          
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="row mt-3">
                <div className="col-md-2">
                    <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <button
                            className="nav-link active text-start bg-white btn-gradient-sty font-12 semibold-text mb-2"
                            id="v-pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-home"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-home"
                            aria-selected="true"
                        >
                            Offer Details
                        </button>
                        <button
                            className="nav-link text-start bg-white btn-gradient-sty font-12 semibold-text"
                            id="v-pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-profile"
                            aria-selected="false"
                            hidden={hideOfferLetter}
                        >
                            Offer Letter
                        </button>
                    </div>
                </div>
                <div className="col-md-10">
                    <div className="tab-content" id="v-pills-tabContent">
                        {/**/}
                        {insertToast ? (
                            <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} />
                        ) : null}
                        <div className="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <div className="accordion-item border-rad">
                                        <p className="accordion-header" id="heading-one">
                                            <button
                                                className="accordion-button acordion-dgr ofr-accordion-sizes collapsed bg-white border-rad"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne"
                                                aria-expanded="false"
                                                aria-controls="collapseOne"
                                            >
                                                <a className="mb-0 semibold-text edit-icon decoration font-14">
                                                    <span class="me-2 float-start accordion-edit-icon completed-status"></span>
                                                    {/* <span className="me-2 float-start accordion-edit-icon" /> */}
                                                    <span className="float-start">Personal Details</span>
                                                </a>
                                            </button>
                                        </p>
                                        <div
                                            id="collapseOne"
                                            className="accordion-collapse accordion-container collapse"
                                            aria-labelledby="collapseOne"
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                <div className="col-md-12">
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                First Name
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="first_name"
                                                                className="form-control"
                                                                value={overviewData.first_name}
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Middle Name
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="middle_name"
                                                                className="form-control"
                                                                value={overviewData.middle_name}
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Last Name
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                name="last_name"
                                                                type="text"
                                                                value={overviewData.last_name}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Gender
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                name="gender"
                                                                value={overviewData.gender}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder="Male"
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Date of Birth
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                name="dob"
                                                                type="date"
                                                                value={moment(overviewData.date_of_birth).format('YYYY-MM-DD')}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Street
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={overviewData.street}
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                City
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={overviewData.city}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                State / Province
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={overviewData.state}
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Country
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={overviewData.country}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                ZIP/Postal Code
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={overviewData.pincode}
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Email Address
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={overviewData.email_id}
                                                                disabled={isDisabled}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Contact Number
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                value={overviewData.mobile_number}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Alternate Contact Number
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                disabled={isDisabled}
                                                                value={overviewData.alternate_mobile_number}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item border-rad mt-4">
                                        <p className="accordion-header" id="heading-two">
                                            <button
                                                className="accordion-button ofr-accordion-sizes collapsed bg-white border-rad"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapsetwo"
                                                aria-expanded="false"
                                                aria-controls="collapseTwo"
                                            >
                                                <a className="mb-0 semibold-text edit-icon decoration font-14">
                                                    {greenOffer ? (
                                                        <span
                                                            onClick={() => {
                                                                setShowJobDetails(false);
                                                            }}
                                                            className="me-2 float-start accordion-edit-icon"
                                                        />
                                                    ) : (
                                                        <span class="me-2 float-start accordion-edit-icon completed-status"></span>
                                                    )}

                                                    <span className="float-start">Job Details</span>
                                                </a>
                                            </button>
                                        </p>
                                        <div
                                            id="collapsetwo"
                                            className="accordion-collapse accordion-container collapse"
                                            aria-labelledby="collapsetwo"
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                <div className="col-md-12">
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Department
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                name="department"
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                value={candidateJobsData.department}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Job Title
                                                            </label>
                                                            <input
                                                                type="text"
                                                                value={candidateJobsData.job_title}
                                                                className="form-control"
                                                                name="jobTitle"
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Employee Type
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                name="employeeType"
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                value={candidateJobsData.employment_type}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Job Location
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="jobLocation"
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                id="exampleFormControlInput1"
                                                                value={candidateJobsData.location}
                                                                disabled
                                                            />
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Offer Valid till
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                name="offerValid"
                                                                value={candidateJobsData.offerValid}
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                id="exampleFormControlInput1"
                                                                placeholder=""
                                                                disabled={hideInputField}
                                                                min={new Date().toISOString().split('T')[0]}
                                                            />
                                                            <label className="text-danger">{offervalid}</label>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Reporting Manager
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                name="reportingManager"
                                                                value={candidateJobsData.reportingManager}
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                placeholder="Enter Name"
                                                                disabled={hideInputField}
                                                            />
                                                            <label className="text-danger">{report}</label>
                                                        </div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                HR Partner
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="HRPartner"
                                                                value={candidateJobsData.HRPartner}
                                                                onChange={(e) => {
                                                                    handleDetails(e);
                                                                }}
                                                                id="exampleFormControlInput1"
                                                                placeholder="Enter Name"
                                                                disabled={hideInputField}
                                                            />
                                                            <label className="text-danger">{hrmanager}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item border-rad mt-4">
                                        <p className="accordion-header" id="heading-three">
                                            <button
                                                className="accordion-button ofr-accordion-sizes collapsed bg-white border-rad"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapsethree"
                                                aria-expanded="false"
                                                aria-controls="collapsethree"
                                            >
                                                <a className="mb-0 semibold-text edit-icon decoration font-14">
                                                    {greenSalary ? (
                                                        <span
                                                            onClick={() => {
                                                                setShowOfferDetails(false);
                                                            }}
                                                            className="me-2 float-start accordion-edit-icon"
                                                        />
                                                    ) : (
                                                        <span class="me-2 float-start accordion-edit-icon completed-status"></span>
                                                    )}
                                                    <span className="float-start">Salary and Compensation Details</span>
                                                </a>
                                            </button>
                                        </p>
                                        <div
                                            id="collapsethree"
                                            className="accordion-collapse accordion-container collapse"
                                            aria-labelledby="collapsethree"
                                            data-bs-parent="#accordionExample"
                                        >
                                            <div className="accordion-body">
                                                <div className="col-md-12">
                                                    <div className="row mb-4">
                                                        <div className="col-md-4">
                                                            <label htmlFor="goal-category" className="form-label  hive-form-label">
                                                                Effective Date
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                name="effectiveDate"
                                                                value={candidateSalaryDetails.effectiveDate}
                                                                onChange={(e) => {
                                                                    handleSalaryDetails(e);
                                                                }}
                                                                disabled={hideInputField}
                                                                min={new Date().toISOString().split('T')[0]}
                                                            />
                                                            <label className="text-danger">{effectDate}</label>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label htmlFor="goal-category" className="form-label  hive-form-label">
                                                                Currency
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example"
                                                                id="goal-category"
                                                                value={candidateSalaryDetails.currency}
                                                                disabled={hideInputField}
                                                                name="currency"
                                                                onChange={(e) => {
                                                                    handleSalaryDetails(e);
                                                                }}
                                                            >
                                                                <option value="">Select</option>
                                                                <option value={1}>INR</option>
                                                                <option value={2}>USD</option>
                                                            </select>
                                                            <label className="text-danger">{currencyValidation}</label>
                                                        </div>
                                                        <div className="col-md-4">
                                                            <label
                                                                htmlFor="exampleFormControlInput1"
                                                                className="form-label hive-form-label"
                                                            >
                                                                Annual CTC
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="exampleFormControlInput1"
                                                                placeholder="Enter CTC"
                                                                value={candidateSalaryDetails.annualCtc}
                                                                disabled={hideInputField}
                                                                onChange={(e) => {
                                                                    handleSalaryDetails(e);
                                                                }}
                                                                name="annualCtc"
                                                            />
                                                            <label className="text-danger">{annualctcvalidation}</label>
                                                        </div>
                                                        <div className="col-md-4 mt-3">
                                                            <label htmlFor="goal-category" className="form-label  hive-form-label">
                                                                Add HR Signature
                                                                <span className="hive-form-mandatory">*</span>
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example"
                                                                id="goal-category"
                                                                value={candidateSalaryDetails.HRsign}
                                                                disabled={hideInputField}
                                                                onChange={(e) => {
                                                                    handleSalaryDetails(e);
                                                                }}
                                                                name="HRsign"
                                                            >
                                                                <option selected="">Select</option>
                                                                <option value={1}>Anthea</option>
                                                            </select>
                                                            <label className="text-danger">{hrSignValidation}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-end mb-5 me-3">
                                    <button
                                        onClick={() => {
                                            next();
                                        }}
                                        className="btn hive-btn-primary"
                                        disabled={hideOfferLetter || saveClick}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                        <GenerateOfferletter
                            hidden={hideOfferLetter}
                            personalDetails={overviewData}
                            salaryDetails={candidateSalaryDetails}
                            jobTitle={candidateJobsData.job_title}
                            offerValid={candidateJobsData.offerValid}
                        />
                        {/* <Loader isloading={isLoading} /> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OfferLetter;
